import { Constants } from '@app/common/constants';
import { HideNewsComments } from '@app/common/hide-news-comments';
import { HideNewsLikes } from '@app/common/hide-news-likes';
import { ManagedPropertyConfig } from '@app/common/managed-property-config';
import { NavigationMode } from '@app/common/navigation-mode.';
import { NewsModeFeaturedNews, NewsModePersonalNews } from '@app/common/news-mode';
import { PrivacySetting } from '@app/common/privacy-setting';
import { RssFeeds } from '@app/common/rss-feed';
import { TrendingResult } from '@app/common/trending-result';
import { ColleagueProperty } from '@app/models/colleague-property';
import { CustomSearchResultConfig } from '@app/models/custom-search-result-config';
import { CustomerSpecificProperty } from '@app/models/project-selection-additional-properties';
import { GITVERSION } from '@environments/git-version';
import { FilterButtonInfo } from '@app/models/filter-button-info';
import { EmailThemeConfig } from '@app/common/email-theme-config';

/* tslint:disable */
export class EnvironmentFeatureSettings {

  /** Allows hiding "mylaunch" icons in the top bar*/
  showBroadcastsIconInTopNav?: boolean = true;
  showSearchbarInTopNav?: boolean = true;

  /** Allow configure if and when comments and likes should be hidden for news. */
  hideNewsComments?: HideNewsComments;
  hideNewsLikes?: HideNewsLikes;
  hideNewsTags?: boolean = true;

  /** Set these to configure whether to should the broadcast label */
  showMessageBroadcastCriticalLabel?: boolean = true;
  showMessageBroadcastWarningLabel?: boolean = true;
  showMessageBroadcastInformationLabel?: boolean = true;

  /** TODO: Need explanation here ?? */
  disableOverlayOnInfoBoxes?: boolean = false;

  /** Allows configuring to show the 'new'-badge on app tiles. */
  showNewOrModifiedbadgeOnAppTile?: boolean = true;

  /** Allows changing default privacy setting when creating groups */
  defaultCreateGroupPrivacySetting?: PrivacySetting;

  /** Should level 3 nodes start collapsed on the "Find information" page?
   Does not look as good, but useful when lots of nodes
   Default is false, meaning all nodes are expanded. The expand arrow is also hidden. */
  enabledCollapsableNodesOnFindInformation?: boolean = false;

  /**  If a node in a section has 3 levels this setting automatically sets a separate design for the node headers - Set to false to hide third level completely - requested by PE */
  enableThirdLevelMenusInFindInformation?: boolean = true;

  /** If set, the "new collaboration site" button will open this url instead of our own form */
  redirectCreateGroupButtonToUrl?: string;

  /** This property should be used for setting the title the head tag. it defaults to Workplace if nothing is set. */
  title?: string = Constants.DEFAULT_TITLE;

  /** This should be set to the company name or the name of the Workplace site. This is used as a prefix to the 'Today' tab. E.g. 'Contoso today' */
  workplaceName?: string;

  /** This should be set to the type of news mode the customer will use in the Featured News widget */
  newsModeFeaturedNews?: NewsModeFeaturedNews = NewsModeFeaturedNews.GraphFromNewsCenterSite;

  /** This should be set to the type of news mode the customer will use in the Personal News widget. */
  newsModePersonalNews?: NewsModePersonalNews = NewsModePersonalNews.GraphFromNewsCenterSite;

  /** This should be set to the site where the customer will publish all news pages that they want to promote on workplace Example: 'https://booldemo.sharepoint.com/sites/news' */
  newsCenterSiteUrl?: string;

  /** Decides where to send the use when clicking on show all news link */
  newsArchiveLink: string;

  /** Enable the archive news filter in the news center to provide filtering options for archived news pages. By default it is off*/
  newsArchiveFilter?: boolean = false;

  /** Decides where to send the user when clicking on links that go to the SharePoint news center */
  sharePointNewsCenterUrl: string;

  /** Exclude sites from news search Example: ['https://booldev.sharepoint.com/sites/abc', 'https://booldev.sharepoint.com/sites/def'] */
  excludeSitesFromNewsSearch?: Array<string> = null;

  /** Allows limiting who is allowed to use the collaboration creation wizard. Defaults to true. If false, code verifies that user is member of 'Workplace Collab Creators' group */
  everyoneCanCreateCollabSites?: boolean = true;

  /** RSS feed configurations*/
  rssFeedConfig?: RssFeeds = null;

  /** News filter buttons configurations*/
  newsFilterButtonConfig?: Array<FilterButtonInfo> = null;

  /** Set this to false to disable SignalR push notifications */
  enableSignalR?: boolean = true;

  /** Set this to false to disable the checks for updated content */
  enableUpdateChecksForNewContent?: boolean = true;

  /** If collab index sites with teams, set this to true to redirect to teams by defaul, if false by default redirects to SharePoint site instead teams.*/
  redirectToTeamsByDefault?: boolean = true;

  /** This should be set to the type of trending result the customer will use. SharePoint means to search for trending result from Communication and team sites as per SPO default.*/
  trendingResult?: TrendingResult;

  /** By setting this to false we can turn off the first day wizard popup that appears for users who have not completed the first day wizard*/
  enableFirstDayPopupDialog?: boolean = true;

  /** By setting this to false we can turn off the automatic sync for the users channel and AD properties that gets done automatically on first load every day */
  enableAutoUserChannelSync?: boolean = true;

  /** Allows editors and/or admins to de-select pushed channels. The "Hide non-mapped channels" feature is also inactivated. This is useful to test different channel combinations. */
  noChannelSelectionLimitationsForAdmins?: boolean = false;
  noChannelSelectionLimitationsForEditors?: boolean = false;

  /** Enable required reading component*/
  enableRequiredReading?: boolean = false;

  /** Allow a user to mark a document or page as read directly from the component (i.e. without nactually having clicked)*/
  allowMarkAsReadFromReqReadList?: boolean = false;

  /** Picks up both draft and published versions in RR List Webpart (useful when approval is turned on), if disabled = only published versions are picked up. */
  includeDraftsInReqReadList?: boolean = false;

  /** Add prefix to o365 groups as per customer naming policy */
  prefixToO365Groups?: string;

  /** This property determines where to send users when clicking on show more results in header search. */
  searchCenterUrl?: string = 'https://www.office.com/search?auth=2&q=';

  /** This property enables a customer to reconfigure the managed properties used by search based components */
  managedPropertyConfig?: ManagedPropertyConfig;

  /** Set the navigation mode being used for the mega menu. */
  navigationMode?: NavigationMode;

  /** This property enables a customer to set a custom navigation termset to use for the mega menu when navigation mode is set to 'TermSet'. */
  navigationTermSet?: string;

  /** Contains the environment specific tracking key used by GA */
  gtmTrackingKey?: string ='';

  /** Contains the environment specific tracking key used by GA */
  gaTrackingKey?: string = '';

  /** Contains the environment specific tracking key used by AppInsights */
  appInsightsTrackingKey?: string;

  customSearchResult?: CustomSearchResultConfig = null;

  /** Show the hubsite filter in search */
  showHubSiteFilterInSearch?: boolean = false;

  /** Default state of hubsite filtering in search */
  hubSiteFilterInSearchDefault?: boolean = false;

  /** This property enables the customer to show or hide regular SharePoint sites in site index.*/
  hideNonGroups?: boolean = true;

  /** Add hotjar key to track workplace*/
  hotJarKey?: string;

  /** Enable right section in find information*/
  enableRightSection?: boolean = false;

  /**
   * Root term which my colleague will fetch all child terms and show as a tree. Must be configured for my colleagues to work.
   * Most customers can probably use the old "Organization" sub term for channels with id: fdc4ef06-e425-40ca-8483-57e0e7118a0f
   */
  myColleagueRootTerm?: string;

  /** If you want to show department for my colleagues */
  myColleaguesShowDepartment?: boolean = true;

  /** If you want to show location for my colleagues */
  myColleaguesShowLocation?: boolean = true;

  /** If you want to show office phone (in addition to mobile phone) for my colleagues */
  myColleaguesShowOfficePhone?: boolean = false;

  /** If you want to show link to MS Teams organizational chart */
  myColleaguesShowOrgChart?: boolean = false;

  /** How many persona are fetched from the graph API, increase this value if the customer think my colleagues search sometimes is capped at too few reults **/
  myColleagueNumberOfGraphResultsCap?: number = 20;

  /** Filter to append to the user service query, for example to hide admin accounts from Workplace **/
  userServiceAppendedFilter?: string = '';

  /** Top search uses SP User Services to find people. But not all properties are synced from Azure AD. Enabled by default to fetch the user from graph (with all properties) when expanding the people card in results. This should enasure that people cards in Find Colleague and Top Seach have the same content. */
  useGraphToExtendPeopleSearch?: boolean = true;

  /** Set to false if you want to hide the description of pages and news for search results*/
  showDescriptionInSearchResult?: boolean = true;

  /** Set this to true if you wish to use the suggestions mode instead of appending the asterisk to search term - if suggestion mode is enabled the asterisk will not be used */
  useSearchSuggestionMode?: boolean = false;

  /** Did You Mean shows suggestions in the search bar. Source of suggestions is manually configured. Matching uses fuzzy search to suggest mistypings, shortcuts, aliases and so forth */
  useSearchDidYouMean?: boolean = false;

  /** Customer needs a specific license to be allowed to configure this.
   * If you want to enable profile card view instead navigating user to delve */
  enableProfileCardView?: boolean = false;

  /** Term set id from which the user profile page will show the users organizational breadcrumb.*/
  profileCardOrganizationTermSetId?: string;

  /** Customer needs a specific license to be allowed to configure this.
    If you want to enable user experience in the user resume */
  enableUserExperience?: boolean = false;

  /** Customer needs a specific license to be allowed to configure this.
   * If you want to enable search from custom database source*/
  enableSearchFromCustomDB?: boolean = false;

  /** Customer needs a specific license to be allowed to configure this.
 * If you want to enable project section in profiler*/
  enableProjectSection?: boolean = true;

  /** Configure customer specific properties in project section in profiler*/
  customerProperties?: Array<CustomerSpecificProperty>;

  /** Set to a URL wher the user can change their profile picture */
  changePictureUrl?: string;

  /** default color codes to editor insight charts */
  chartsBackground?: Array<string> = ['#cc2e64', '#0C7191', '#C7DAEA', '#b300b3', '#ff6666', '#ff9933', '#3366ff', '#80ff00', '#3366ff', '#ffbb33'];

  /** This option is by default true to support toggle between Sp news pages and WP pages and should be set as false in coreIntranet as it support on SP news page.*/
  togglePagesFromSPorWP?: boolean = true;

  /** Configurable properties for Your colleagues- each customer can pick 0-2 properties (default is "Department" and "State")*/
  colleagueProperties?: ColleagueProperty = {
    Property1: {
      Label: 'Department',
      Name: 'Department'
    },
    Property2: {
      Label: 'State',
      Name: 'State'
    }
  };

  /** Set to true to show the birthday calendar component, NOTE you will need to have the birthday module included in the project for it work */
  showBirthdayCalendar?: boolean = false;

  /** Set to true to show the restaurant menu component, NOTE you will need to have the restaurant menu module included in the project for it work */
  showRestaurantMenus?: boolean = false;

  /** Set the default size of images when fetching images from SharePoint. By selecting a larger size the performance will suffer.
   * Notes: 'c400x99999' is what SharePoint Modern seems to use most of the time. This might be better since we can assume that it is the size most likely to be cached and ready to use.
   *        'medium' seems to give the same dimensions as c400x99999, unless the image is tall. For our purposes both seems to work fine (however: c400x99999 is more specific. We can never know what medium will return in the future.)
   *        Size options: https://docs.microsoft.com/en-us/graph/api/driveitem-list-thumbnails?view=graph-rest-1.0&tabs=http#size-options
   *        Keeping medium for now, since this makes it easy for us to let the customer change between 'small', 'medium' and 'large' from the admin dashboard
   */
  defaultImageThumbnailSize?: string = 'medium';

  /** Set this to true if the Audit trail functionality is enabled on server side (AuditTrailEnabled=true) and you wish to be able to view the audit trail for apps, pages etc.
   * This also enables restoring of previous "versions" for these items.*/
  auditsEnabled?: boolean = false;

  /** Set this to true to have the entire header element as a sticky element following along when scrolling. */
  stickyHeader?: boolean = false;

  /** Show news description in Find information, Top news and Your news. */
  showNewsDescription?: boolean = false;

  /** Allows configurable attributes fetched from graph for getMyDetailsFromMsGraph */
  myDetailsMsGraphProperties?: Array<string> = [
    'id',
    'displayName',
    'mail',
    'assignedPlans',
    'assignedLicenses',
    'city',
    'country',
    'jobTitle',
    'state',
    'department',
    'companyName',
    'officeLocation',
    'userPrincipalName',
    'extension_091508dac99d46a1ae24ad9e0373e94b_extensionAttribute6',
    'extension_9c71bd435c4f4809a6135eb366b97902_department',
    'mobilePhone'
  ];

  /** Enables the app to be iframed in Core Intranet **/
  coreIntranetEnabled?: boolean = false;

  /** Option to enable or disable smartlinks (Apps and Tools) **/
  smartLinksEnabled?: boolean = true;

  /** Option to enable or disable Total visits section of Site analytics in editorDashboard. **/
  editorInsightsShowTotalVisits?: boolean = true;

  /** Set this to the host url where commento is deployed example: http://commento-dev-01.westeurope.azurecontainer.io:8080/js/commento.js */
  commentoScriptUrl?: string;

  /** Set this to false if you want the license filter to apply in the top navigation - useful for WP light customers*/
  bypassLicenseFilterInTopNav?: boolean = true;

  /** Set this to true to add a team by default to the create collab site wizard **/
  addTeamByDefault?: boolean = false;

  /** Set this to true to enable the language filtering of modern Sharepoint news pages. Note this requires that the language setting is turned on on the News Center Site*/
  enableModernSPNewsLanguageFilter?: boolean = false;

  // Enable users languages to sync based on AD properties
  enableAutoUserLanguageSync?: boolean = false;

  // Enable syncronization of Azure AD groups to WP channels
  enableAzureADGroupSync?: boolean = false;

  // Enable language filtering for SharePoint pages
  enableLanguageFilteringForSharepointPages?: boolean = false;

  // Enable language filtering for SharePoint infoboxes
  enableLanguageFilteringForWorkplaceInfoboxes?: boolean = false;

  // Enable language filtering for SharePoint events
  enableLanguageFilteringForSharepointEvents?: boolean = false;

  // Enable language filtering for Workplace content
  enableLanguageFilteringForWorkplace?: boolean = false;

  // If enabled, items without any languages selected will be shown to everyone. If disabled items without language will generally not be shown.
  enableShowNonLanguageContentForAllUsers?: boolean = false;

  /**
   * Specify a term guid from the languages term set.
   * If set, this will act as a default language for filtering purposes for users that doesn't have any selected languages.*/
  defaultLanguageTermId?: string;

  /** Set this to true to enable the 'add to homescreen banner' for IOS devices*/
  enableIosA2hsBanner?: boolean = false;

  /**
   * Set this to true to have all links open in the current tab except apps and tools. Including external links such as sharepoint news etc
   * When enabled the target attribute (i.e. target="_blank") is set to "_self"
  */
  openAllLinksInSameTab?: boolean = false;

  /**
   * Set this to true to have apps and tools open in the current tab.
   * When enabled the target attribute (i.e. target="_blank") is set to "_self"
  */
  openAppAndToolsInSameTab?: boolean = false;

  /** Set this to a custom image if you want to override the default one or set it to null when using the Azure CDN for improved performance*/
  firstDayBackgroundImage?: string = `assets/cellphone-coffee-desk-860379.jpg?v=${GITVERSION.hash}`

  /** Set this to false to disable the possibility to mark a page as featured */
 enableFeaturedPages?: boolean = true;

  /** Set this to tru to enable the notification subscription for broadcasts and news */
  enableNotificationSubscriptions?: boolean = false;

  /**
   * These SkipLinks are targeted to main content and footer
   * All the component skip links are populated dynamically with in the code.
  */
  staticSkipLinks?: {
    "Sections": [
      {
        "Id": "main-content",
        "Name": "Content"
      },
      {
        "Id": "footer",
        "Name": "Footer"
      },
    ]
  };

  /** Set this to false to hide the title in the refresh dialog */
  showRefreshDialogTitle?: boolean = true;

  /** Toggle this to enable or disable the popover in site index */
  enableSiteIndexPopover?: boolean = true;

  /** Set a url that will take user to an iamge gallery where the user can upload an image and then copy the url to the infobox picture url field*/
  infoBoxPictureGalleryLink?: string;

  /** Toggle this to enable or disable the migrate button in the infobox list view. It will be hidden when a migration has been performed once */
  infoBoxShowMigrateBtn?: boolean = true;

  /** Enable to show a link to the users Delve page on the user menu */
  showGoToDelveOnUserMenu?: boolean = false;

  /** Enable to collapse channel lists in user settings if more than 5 channels */
  enableCollapsableChannels?: boolean = false;

  /** Set this to a custom image if you want to override the default one or set it to null when using the Azure CDN for improved performance*/
  infoboxImageUploadinstructionsImage?: string = `assets/infobox-picture-help.png?v=${GITVERSION.hash}`

  /** Set this to a custom image if you want to override the default one or set it to null when using the Azure CDN for improved performance*/
  powerBIEmbedCodeUploadinstructionsImage?: string = `assets/powerbi-embed-picture-help.png?v=${GITVERSION.hash}`

  /** Set this to a custom image if you want to override the default one or set it to null when using the Azure CDN for improved performance*/
  powerBIBookmarkUploadinstructionsImage?: string = `assets/powerbi-bookmark-picture-help.png?v=${GITVERSION.hash}`

  /** Enable to make the channel selection required when adding a new BroadcastMessage */
  requireChannelSelectionForBroadcastAlerts?: boolean = false;

  /** Enable to make the channel selection required when adding a new PowerBI visual */
  requireChannelSelectionForPowerBIVisuals?: boolean = false;

  /** Enable to show SharePoint news center link to all users on News center page */
  showSharePointNewsCenterLink?: boolean = false;

  /** Result source ID for finding people, defaults to the built in GUID of Local People Results**/
  peopleResultSourceId?: string = 'b09a7990-05ea-4af9-81ef-edfab16c4e31'

  /** Enable to show the news filter buttons between your news and top news */
  showFilterByDepartmentButtons?: boolean = false;

  /** Disable expensive api calls to store the data in the local storage which adds up some response time but it works*/
  /** Note that this setting only applies to certain selected calls and not generally across workplace. */
  disableLocalStorage?: boolean = false;

  /** Set this to false to close the filter dropdown in news center page, it will be open as default */
  showFilterInNewsCenter?: boolean = true;

/** Number of days back to fetch news. Default is 30 days back, but this can be changed in admin settings. */
  newsNumberOfDaysBack?: number = 30;

  /** Configure news or page icons in top search, supports both image and font awesome icons if both iconClass and iconUrl are configured than icon class takes precedence*/
  newsOrPageIconsInSearch? = {
    news: {
      iconClass: '',
      iconUrl: ''
    },
    page: {
      iconClass: '',
      iconUrl: ''
    }
  };

  /** Set to true to show the PowerBI component, NOTE you will need to have the PowerBI module included in the project for it to work */
  showPowerBIComponent?: boolean = false;

  /** Set to true to show teams notification option in users settings page, NOTE: before setting this option to true, configure teams notification feature in customer environment. */
  enableTeamsNotification?: boolean = false;

  /** Set this to a custom image if you want to override the default one or set it to null when using the Azure CDN for improved performance*/
  teamsNotificationInstructionsImage?: string = `assets/enable-teams-notification-instructions.png?v=${GITVERSION.hash}`

  /** Set the CHANNEL_TERMSET_GUID here, good to use only in customer test environments, this could be overriden from Admin dashboard.*/
  channelTermsetGUID?: string = 'd1a62611-0513-4d6a-92e2-9b250a08c5c3';

  /** set this to show guide link in the top navigation */
  showGuideNavigation?: boolean = false;

  /** This should be set to the SharePoint Guide URL. Example: 'https://booldemo.sharepoint.com/sites/guide' */
  guideSiteUrl?: string;

  /** set this to add a link in the top navigation. URL: where you want the link to go, Title: what it says in top nav */
  linkTopNav?: {
      title: string,
      url: string,
      target:string
  };

  /** Set URL link to ImageVault if used when uploading images to news pages */
  imageVaultUrl?: string;

  /** Set URL link to calendarPageInformation if you like to have this url in the description below the header of Organization calendar   */
  calendarPageInfoUrl?: string;

  /** enabled by default and works only for customers with default today board layout else there is no change inspite it is enabled in admin dashboard */
  enableCompactDesign?: boolean = true ;

  /** Set appropriate query to see all the events with in the range in SharePoint, upon redirected from 'go to the calender' link upcoming events feature*/
  eventsDisplayQuery?: string = '';

  /** Set up support contact email*/
  supportContactEmail?: string = '';

  /** Set up support contact email*/
  supportContactPhone?: string = '';

  /** Show or hide recommended serach results result box based on the settings in admin dashboard by default is enabled*/
  enableRecommendedSerachResultsSection ?: boolean = true ;

  /** Show or hide pages serach results result box based on the settings in admin dashboard by default is enabled */
  enablePagesSerachResultsSection ?: boolean = true ;

  /** Show or hide people serach results result box based on the settings in admin dashboard by default is enabled */
  enablePeopleSerachResultsSection ?: boolean = true ;

  /** Show or hide collab sites serach results result box based on the settings in admin dashboard by default is enabled */
  enableCollabSitesSerachResultsSection ?: boolean = true ;

  /** Show or hide apps and tools serach results result box based on the settings in admin dashboard by default is enabled */
  enableAppsToolsSerachResultsSection ?: boolean = true ;

  /** Show or hide files serach results result box based on the settings in admin dashboard by default is enabled */
  enableFilesSerachResultsSection ?: boolean = true ;

  /** Show or hide news serach results result box based on the settings in admin dashboard by default is enabled */
  enableNewsSerachResultsSection ?: boolean = true ;

  /** Show or hide other serach results result box based on the settings in admin dashboard by default is enabled */
  enableOtherSerachResultsSection ?: boolean = true ;

  /** RSS feed configurations*/
  emailThemeConfig?: EmailThemeConfig = {
    btnBckgroundColor:"#1c87c9",
    btnColor:"#fff",
    footerBckgroundColor: "#fafafa",
    sectionBorderColor: "#378c85",
    settingsPageUrl:""
  };

  /** Email template design image to help set the appropriate parameters*/
  emailThemeConfigImageHelp?: string = `assets/email-template.png?v=${GITVERSION.hash}`;

  /** Set Site to fetch organization calendar events from instead of default coreWorkplaceSiteUrl */
  organizationCalenderSiteUrl ?: string;

}
/* tslint:enable */
